import { InjectionToken } from '@angular/core';
import { environment } from '@lentau/core/environments';

export const MFE_REACT_BASE_PATH: InjectionToken<string> = new InjectionToken<string>('MFE React BasePath');

const mfeReactPostfix: string = 'mfe-react';

export const MfeReactBasePath: (window: Window) => string = (window: Window): string => {
  const host: string = window.location.host;
  // Проверяем, является ли домен lenta.com или stage доменом
  if (host.includes('lenta.com') && !host.includes('dev.lenta.tech')) {
    return `${window.location.origin}/${mfeReactPostfix}`;
  } else {
    return `${environment.MFE_REACT_URL}`;
  }
};
